// @flow

export type NotificationName = 'leadsToNoRecommendation'

export type TogglePayload = {
  name: NotificationName,
  value: boolean
}

export type NotificationState = {
  notification: {
    [key: NotificationName]: boolean
  }
}

export const state: NotificationState = {
  notification: {
    leadsToNoRecommendation: false
  }
}
